module.exports = __webpack_public_path__ + "img/image_slide1_3.015c0a1b.png";